export const PRIVILEGES = {
  ADMIN_PRIVILEGE: 1548,
  AUTOMATION_AREA: 1763,
  BOT_INTEGRATIONS: 1770,
  BOT_BUILDER_ADMIN: 1778,
  BOT_BUILDER_CONTENT_USER: 1779,
  BOT_BUILDER_BUSINESS_USER: 1780,
  BOT_BUILDER_OPERATIONS: 1781,
  BOT_BUILDER_BOTS: 1782,
  CB_CREATE_EDIT_BOTS: 1804,
  CB_VIEW_BOTS: 1805,
  CB_EXPORT_BOTS: 1806,
  CB_IMPORT_BOTS: 1807,
  CB_DELETE_BOTS: 1808,
  CB_CREATE_RELEASE: 1809,
  CB_ACCEPT_RELEASE: 1810,
  CB_CREATE_VERSION: 1811,
  CB_RESTORE_VERSION: 1812,
  CB_CREATE_EDIT_ENTERPRISE_INTEGRATIONS: 1813,
  CB_VIEW_ENTERPRISE_INTEGRATIONS: 1814,
  CB_DELETE_ENTERPRISE_INTEGRATIONS: 1815,
  CB_CREATE_EDIT_API_INTEGRATIONS: 1816,
  CB_VIEW_API_INTEGRATIONS: 1817,
  CB_DELETE_API_INTEGRATIONS: 1818,
  CB_CREATE_EDIT_GLOBAL_FUNCTIONS: 1819,
  CB_VIEW_GLOBAL_FUNCTIONS: 1820,
  CB_CREATE_EDIT_CREDENTIALS: 1821,
  CB_USE_CREDENTIALS: 1822,
  CB_START_A_CONNECTOR: 1823,
  CB_STOP_A_CONNECTOR: 1824,
  CB_CREATE_EDIT_DOMAIN: 1825,
  CB_DELETE_DOMAIN: 1826,
  CB_VIEW_DOMAIN: 1827,
  CB_CREATE_EDIT_INTENTS: 1828,
  CB_VIEW_INTENTS: 1829,
  CB_DELETE_INTENTS: 1830,
  CB_CREATE_EDIT_ENTITIES: 1831,
  CB_VIEW_ENTITIES: 1832,
  CB_DELETE_ENTITIES: 1833,
  CB_TRAIN_MODEL: 1834,
  CB_ACTIVATE_MODEL: 1835,
  CB_CREATE_EDIT_KNOWLEDGE_BASE: 1836,
  CB_VIEW_KNOWLEDGE_BASE: 1837,
  CB_DELETE_KNOWLEDGE_BASE: 1838,
  CB_CREATE_EDIT_ARTICLE: 1839,
  CB_DELETE_ARTICLE: 1840,
  CB_APPROVE_ARTICLE: 1841,
  CB_IMPORT_KNOWLEDGE_BASE: 1842,
  CB_EXPORT_KNOWLEDGE_BASE: 1843,
  CB_VIEW_ANALYTICS: 1844,
  CB_DOWNLOAD_ANALYTICS: 1845,
  CB_PURGE_DATA: 1846,
};

export default PRIVILEGES;
